'use client';

import { PageHeader } from '@/app/(app)/page-main';
import {
  ServiceTypeTemplateProvider,
  useServiceTypeTemplateCtx,
} from '@/app/(app)/settings/service_types/[id]/provider';
import { ServiceTypeTemplateArrivalWindows } from '@/app/(app)/settings/service_types/[id]/tab-arrival-windows';
import { ServiceTypeTemplateDetails } from '@/app/(app)/settings/service_types/[id]/tab-details';
import { ServiceTypeTemplatePests } from '@/app/(app)/settings/service_types/[id]/tab-pests';
import { ServiceTypeTemplateSchedule } from '@/app/(app)/settings/service_types/[id]/tab-schedule';
import { ServiceTypeTemplateSkills } from '@/app/(app)/settings/service_types/[id]/tab-skills';
import { PageTabsList, PageTabsTrigger, Tabs, TabsContent } from '@/components/ui/tabs';
import { useLocationParam } from '@/lib/router';

import { ServiceTypeTemplateReschedule } from './tab-reschedule';

export function ServiceTypePage() {
  const id = useLocationParam('id');
  return (
    <ServiceTypeTemplateProvider id={id}>
      <PageContent />
    </ServiceTypeTemplateProvider>
  );
}

function PageContent() {
  const { serviceTypeTemplate } = useServiceTypeTemplateCtx();

  return (
    <Tabs defaultValue='details'>
      <div>
        <PageHeader
          title={serviceTypeTemplate.name}
          breadcrumbs={[{ label: 'Service Types', href: '/settings/service_types' }]}
        />
        <div className='mt-2 border-b-[0.5px] px-4'>
          <PageTabsList className=''>
            <PageTabsTrigger value='details'>Details</PageTabsTrigger>
            <PageTabsTrigger value='frequency'>Frequency</PageTabsTrigger>
            <PageTabsTrigger value='arrival-windows'>Arrival Windows</PageTabsTrigger>
            <PageTabsTrigger value='pests'>Pests</PageTabsTrigger>
            <PageTabsTrigger value='skills'>Skills</PageTabsTrigger>
            <PageTabsTrigger value='reschedule'>Reschedule</PageTabsTrigger>
          </PageTabsList>
        </div>
        <div className='mx-auto my-14 w-full max-w-2xl px-4 lg:px-0'>
          <TabsContent value='details'>
            <ServiceTypeTemplateDetails />
          </TabsContent>
          <TabsContent value='frequency'>
            <ServiceTypeTemplateSchedule />
          </TabsContent>
          <TabsContent value='pests'>
            <ServiceTypeTemplatePests />
          </TabsContent>
          <TabsContent value='skills'>
            <ServiceTypeTemplateSkills />
          </TabsContent>
          <TabsContent value='arrival-windows'>
            <ServiceTypeTemplateArrivalWindows />
          </TabsContent>
          <TabsContent value='reschedule'>
            <ServiceTypeTemplateReschedule />
          </TabsContent>
        </div>
      </div>
    </Tabs>
  );
}
